/*global jQuery, google */
(function($) {

  'use strict';

  var map,
  infowindow,
  gdc,
  directionsDisplay,
  directionsService,
  calcRoute;

  var addMarker = function(place, onClick) {
    var marker = new google.maps.Marker({
      position: place.position,
      map: map
    });

    place.marker = marker;
    return marker;
  };

  var removeMarker = function(place) {
    if (place.marker) {
      place.marker.setMap(null);
      place.marker = null;
    }

  };

  var initMap = function(mapContainer, lat, lng, info) {

    map = new google.maps.Map(mapContainer, {
      zoom: 15,
      center: new google.maps.LatLng(lat, lng),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false
    });

    infowindow = new google.maps.InfoWindow({
      content: info
    });

    gdc = {
      position: new google.maps.LatLng(
        lat, lng
      )
    };
    var marker = addMarker(gdc);

    infowindow.open(map, marker);
    return map;
  };

  $(function() {
    $('.mappa').each(function() {
      initMap($(this).get(0), $(this).data('lat'), $(this).data('lng'), $(this).html());
    });
	//45.636367, 9.332077

    var attivaModal = function(message, buttons, idButtons, callBack) {
      $('.modal-body p').hide();
      $('.modal-body p').html(message);
      $('.modal-body p').show();

      if (!$('.modal').hasClass('in')) {
        $('.modal').modal('show');
      }

      $('.modal-footer').html('');

      if (typeof buttons !== 'undefined' && buttons !== null) {
        if (buttons.length > 0) {
          $.each(buttons, function(index, value) {
            if (idButtons[index] === '') {
              $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
            } else {
              $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
            }
          });
        }
      }
      if (typeof callBack === 'function') {
        callBack();
      }
    };

    /* validation form cv */
    
    $('body').on('click', '.invia-contatto', function() {
      
      var validator = $('#form-contatto').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          nome: {
            required: true
          },
          cognome: {
            required: true
          },
          captcha: {
            required: true
          },
          telefono: {
            required: true
          },
          messaggio: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          privacy: {
            required: true
          }
        },
        messages: {
          nome: {
            required: testiMultilingua.texts.testi['inserire-nome']
          },
          cognome: {
            required: testiMultilingua.texts.testi['inserire-cognome']
          },
          messaggio: {
            required: testiMultilingua.texts.testi['inserire-messaggio']
          },
          privacy: {
            required: testiMultilingua.texts.testi['check-privacy']
          },
          captcha: {
            required: testiMultilingua.texts.testi['inserire-captcha']
          },
          telefono: {
            required: testiMultilingua.texts.testi['inserire-telefono']
          },
          email: {
            required: testiMultilingua.texts.testi['inserire-mail'],
            email: testiMultilingua.texts.testi['mail-corretta']
          }
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });

      var arr = {};
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.nome = $('#nome').val();
      arr.cognome = $('#cognome').val();
      arr.messaggio = $('#messaggio').val();
      arr.captcha = $('#captcha').val();
      arr.pagina_id = $('#pagina_id').val();
      var jsonString = JSON.stringify(arr);


      if (validator.form()) {
        var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
        '<h4>Stiamo elaborando la sua richiesta, attendere un attimo...</h4><br><br>';
        attivaModal(tmpl, null, null);

        var fd = new FormData();
        fd.append('action', 'invia-email');
        fd.append('obj', jsonString);

        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            if (arr[0] === '1') {
              tmpl = '<span class="glyphicon glyphicon-send" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
              $('#email').val('');
              $('#nominativo').val('');
              $('#telefono').val('');
              $('#messaggio').val('');
              $('#captcha').val('');

            } else {
              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
            }
            attivaModal(tmpl, ['Chiudi'], [''], null);
          }
        });
        return false;
      }
      return false;
    });

  });

}(jQuery));